import { z } from 'zod';

export const DeleteOrderUrlSchema = z.object({
    id: z.string().uuid(),
});
